module.exports = __webpack_public_path__ + "img/file_excel.66685bae.svg";